import * as swcHelpers from '@swc/helpers';
import { selectors } from './selectors.js';

const reducer = (state, action)=>{
    switch(action.type){
        case 'setPurchaseType':
            {
                const { purchaseType  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        purchaseType
                    })
                });
            }
        case 'setDeliveryInterval':
            {
                const { deliveryInterval  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        subscriptionPurchaseConfigurations: swcHelpers.objectSpread({}, state.configurations.subscriptionPurchaseConfigurations, {
                            deliveryInterval
                        })
                    }),
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        deliveryInterval: {
                            showError: false
                        }
                    })
                });
            }
        case 'setQuantity':
            {
                const { quantity  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        quantity
                    })
                });
            }
        case 'triggerErrors':
            {
                const isConfiguratorValid = selectors.isConfiguratorValid(state);
                if (isConfiguratorValid) {
                    return state;
                }
                const isDeliveryIntervalValid = selectors.isDeliveryIntervalValid(state);
                const { invalidSubmissionsCount: previousCount , deliveryInterval  } = state.configurator;
                const newCount = (previousCount || 0) + 1;
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: newCount,
                        deliveryInterval: swcHelpers.objectSpread({}, deliveryInterval, {
                            showError: isDeliveryIntervalValid === false
                        })
                    })
                });
            }
        case 'resetErrors':
            {
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: undefined,
                        deliveryInterval: swcHelpers.objectSpread({}, state.configurator.deliveryInterval, {
                            showError: false
                        })
                    })
                });
            }
        default:
            return state;
    }
};

export { reducer };
//# sourceMappingURL=reducer.js.map
